export type WireFieldConfig = {
  field: API.WireImport.WireField;
  labelKey: string;
  required: boolean;
};

export const WIRE_FIELDS: WireFieldConfig[] = [
  {
    field: "recipient_name",
    labelKey: "column-mapping-field-recipient-name",
    required: true,
  },
  {
    field: "amount",
    labelKey: "column-mapping-field-amount",
    required: true,
  },
  {
    field: "account_number",
    labelKey: "column-mapping-field-account-number",
    required: true,
  },
  {
    field: "routing_number",
    labelKey: "column-mapping-field-routing-number",
    required: true,
  },
  {
    field: "memo",
    labelKey: "column-mapping-field-memo",
    required: true,
  },
  {
    field: "wire_reason",
    labelKey: "column-mapping-field-wire-reason",
    required: true,
  },
  {
    field: "recipient_street_address",
    labelKey: "column-mapping-field-recipient-street-address",
    required: true,
  },
  {
    field: "recipient_city",
    labelKey: "column-mapping-field-recipient-city",
    required: true,
  },
  {
    field: "recipient_region_code",
    labelKey: "column-mapping-field-recipient-region-code",
    required: true,
  },
  {
    field: "recipient_postal_code",
    labelKey: "column-mapping-field-recipient-postal-code",
    required: true,
  },
];
